<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent && !windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Pro Search Agent'"
      [customBack]="'pro-search-agent'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (windowService.isDesktopRes && !isRightSideContent) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-text
            [title]="'My Pros'" />
          <form [formGroup]="form" novalidate action="#" class="bills-form-filters form-filters">
            <div class="desktop-item">
              <tidy-select
                class="select-custom-input"
                [label]="'Property'"
                [icon]="'assets/svg/home.svg'"
                [items]="addressFilter"
                [form]="form.get('property')"
                formControlName="property"
                (optionChange)="changeAddress($event)" />
            </div>
            <div class="desktop-item">
              <tidy-select
                class="select-custom-input"
                [label]="'Service Type'"
                [icon]="'assets/svg/list.svg'"
                [items]="serviceCategoryItems"
                [form]="form.get('service')"
                formControlName="service"
                (optionChange)="changeServiceCategory($event)" />
            </div>
          </form>
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      @if (!hasAddresses) {
        <tidy-row [align]="'center'">
          <tidy-text [body]="'Please add a property to view checklists.'" />
        </tidy-row>
        <tidy-button
          [text]="'Add Property'"
          [action]="goToDashboard.bind(this)"
          class="primary" />
      }
      @if (hasPros && hasAddresses) {
        @if (!windowService.isDesktopRes || isRightSideContent) {
          <tidy-two-column-row class="extra-bottom-padding">
            <tidy-filter
              [label]="'Property'"
              [showLabels]="true"
              [initValue]="addressId"
              [items]="addressFilter"
              (optionChange)="changeAddress($event)" />
            <tidy-filter
              [label]="'Service Category'"
              [showLabels]="true"
              [initValue]="categoryId"
              [items]="serviceCategoryItems"
              (optionChange)="changeServiceCategory($event)" />
          </tidy-two-column-row>
        }
        <tidy-row>
          <tidy-text
            [body]="priorityListSentence"
            style="margin-right:5px" />
          <tidy-text
            [body]="'Add Pro'"
            (action)="addPro()"
            class="link" />
        </tidy-row>
        @if (hasAutoAssignProInList()) {
          <tidy-row>
            <tidy-alert class="green-background">
              <tidy-text
                [body]="'If the auto-assign pro cancels, other pros will be contacted in the same priority order shown above. Pros listed before the auto-assign pro will be contacted first.'" />
            </tidy-alert>
          </tidy-row>
        }
        <tidy-row [alignLastItemRight]="true">
          <tidy-row [alignLastItemRight]="true" class="full-width">
            <tidy-text
              [header]="'Priority List'" />
            <tidy-text
              [body]="'Edit'" />
          </tidy-row>
          <tidy-toggle [toggled]="editPrio" (toggleChanged)="editPrio = !editPrio" class="extra-left-margin" />
        </tidy-row>
        <tidy-drag-drop
          dragDropId="approved-dd"
          [connectedDragDropsIds]="['favorites-dd', 'blocked-dd']"
          [dataList]="prosData?.favorited"
          emptyListColor="green"
          emptyListMessage="No Pros Added"
          emptyDisabledListMessage="No Pros Added"
          [disabled]="!editPrio"
          (listDropped)="updatePriorities()">
          @for (item of prosData?.favorited; track item; let i = $index; let last = $last) {
            <ng-container *tidyDragDropItem>
              @if (!editPrio) {
                <tidy-card [style.opacity]="isProSkippedDueToAutoAssign(i) ? '0.5' : '1'">
                  @if (!item?.object_type) {
                    @for (pro of item; track pro; let proIndex = $index) {
                      <div [style.opacity]="shouldReduceProOpacity(i, proIndex) ? '0.5' : '1'" class="pro-item-container">
                        @if (pro?.object_type === 'homekeeper') {
                          <tidy-card-button (action)="goToPro(pro?.object?.id)">
                            <tidy-row>
                              <tidy-text
                                [header]="pro?.object?.name | abbrLastName"
                                [translate]="false" /><span>&nbsp;</span>
                              @if (pro?.ignore_homekeeper_availability) {
                                <tidy-text
                                  [helper]="'(auto assign)'" />
                              }
                            </tidy-row>
                          </tidy-card-button>
                        }
                        @if (pro?.object_type === 'dynamic_sa') {
                          <tidy-card-button [customIcon]="'assets/img/settings.svg'" [hideArrow]="true" (action)="goToTidyFindNewPro(true)">
                            <tidy-row class="vertical-align-center">
                              <tidy-image
                                [src]="'assets/img/search.svg'"
                                class="header-size" />
                              <tidy-text
                                [header]="'Find New Pro'" />
                            </tidy-row>
                            @if (pro?.object?.gender_preference !== 'any') {
                              <tidy-row class="extra-top-padding">
                                <tidy-text
                                  [body]="(pro?.object?.gender_preference | titlecase) + (' Only' | translate)" /><br>
                                <tidy-text
                                  [helper]="'Warning: this setting decreases the number of Pros in your area.'" />
                              </tidy-row>
                            }
                          </tidy-card-button>
                        }
                      </div>
                      <!-- Divider between pros in merged card -->
                      @if (proIndex < item.length - 1) {
                        <div class="pro-divider"></div>
                      }
                    }
                  }
                  @if (item?.object_type) {
                    <div [style.opacity]="shouldReduceProOpacity(i, 0) ? '0.5' : '1'" class="pro-item-container">
                      @if (item?.object_type === 'homekeeper') {
                        <tidy-card-button (action)="goToPro(item?.object?.id)">
                          <tidy-row>
                            <tidy-text
                              [header]="item?.object?.name | abbrLastName"
                              [translate]="false" /><span>&nbsp;</span>
                            @if (item?.ignore_homekeeper_availability) {
                              <tidy-text
                                [helper]="'(auto assign)'" />
                            }
                          </tidy-row>
                        </tidy-card-button>
                      }
                      @if (item?.object_type === 'dynamic_sa') {
                        <tidy-card-button [customIcon]="'assets/img/settings.svg'" [hideArrow]="true" class="arrow-to-top" (action)="goToTidyFindNewPro(true)">
                          <tidy-row class="vertical-align-center">
                            <tidy-image
                              [src]="'assets/img/search.svg'"
                              class="header-size" />
                            <tidy-text
                              [header]="'Find New Pro'" />
                          </tidy-row>
                          @if (item?.object?.gender_preference !== 'any') {
                            <tidy-row class="extra-top-padding">
                              <tidy-text
                                [body]="(item?.object?.gender_preference | titlecase) + (' Only' | translate)" /><br>
                              <tidy-text
                                [helper]="'Warning: this setting decreases the number of Pros in your area.'" />
                            </tidy-row>
                          }
                        </tidy-card-button>
                      }
                    </div>
                  }
                </tidy-card>
              }

              @if (editPrio) {
                <tidy-card [class.highlight]="item?.highlight">
                  <tidy-card-button [hideArrow]="true">
                    @if (!item?.object_type) {
                      @for (pro of item; track pro; let proIndex = $index) {
                        <div [style.opacity]="shouldReduceProOpacity(i, proIndex) ? '0.5' : '1'">
                          <tidy-row [class.next-row]="proIndex > 0">
                            <div class="flex-container">
                              <div>
                                @if (proIndex === 0) {
                                  <tidy-image
                                    class="header-size swap-merged"
                                    [src]="'assets/svg/menu-tidy-green.svg'" />
                                }
                                @if (pro?.object_type === 'dynamic_sa') {
                                  <tidy-text
                                    [header]="'Find New Pro'" />
                                }
                                @if (pro?.object_type !== 'dynamic_sa') {
                                  <tidy-text
                                    [header]="pro?.object?.name | abbrLastName"
                                    [translate]="false" />
                                }
                              </div>
                              <div>
                                @if (pro?.object_type !== 'dynamic_sa') {
                                  <tidy-image
                                    style="
                                      float: right;
                                      height: 20px;
                                      cursor: pointer;
                                      right: -6px;
                                      position: relative;
                                    "
                                    [src]="'assets/svg/trash-black.svg'"
                                    (action)="removeProFromList(pro)" />
                                }
                                <tidy-image
                                  style="
                                    height: 20px;
                                    cursor: pointer;
                                  "
                                  [matTooltip]="'Unmerge' | translate"
                                  [src]="'assets/icon/expand.svg'"
                                  (action)="unmergePro(i, proIndex, 'favorited')" />
                              </div>
                            </div>
                          </tidy-row>
                          @if (pro?.object_type !== 'dynamic_sa') {
                            <tidy-row class="no-padding">
                              <tidy-checkbox
                                [initValue]="pro?.ignore_homekeeper_availability"
                                [items]="[{viewValue: 'Auto Assign', value: true}]"
                                (checkedChange)="updateAutoAssign(pro)"
                                matTooltip="Pro will be assigned immediately without needing to accept"
                                matTooltipShowDelay="200" />
                            </tidy-row>
                          }
                          @if (pro?.object_type !== 'dynamic_sa' && !pro?.ignore_homekeeper_availability && hasAutoAssignProAboveIndex(i)) {
                            <tidy-row class="no-padding">
                              <tidy-text
                                [helper]="'These will only be contacted if the auto assign pro cancels the job'"
                                [style.font-size]="'12px'"
                                [style.color]="'#666'" />
                            </tidy-row>
                          }
                        </div>
                        <!-- Divider between pros in merged card -->
                        @if (proIndex < item.length - 1) {
                          <div class="pro-divider"></div>
                        }
                      }
                    }
                    @if (item?.object_type) {
                      <div [style.opacity]="shouldReduceProOpacity(i, 0) ? '0.5' : '1'">
                        <tidy-row [alignLastItemRight]="item?.object_type !== 'dynamic_sa'" [ngClass]="{'vertical-align-center': item?.object_type === 'dynamic_sa'}">
                          <tidy-image
                            class="header-size"
                            [src]="'assets/svg/menu-tidy-green.svg'" />
                          @if (item?.object_type === 'dynamic_sa') {
                            <tidy-text
                              [header]="'Find New Pro'" />
                          }
                          @if (item?.object_type !== 'dynamic_sa') {
                            <tidy-text
                              [header]="item?.object?.name | abbrLastName"
                              [translate]="false" />
                          }
                          @if (item?.object_type !== 'dynamic_sa') {
                            <div>
                              <tidy-image
                                style="float: right; height: 20px; cursor: pointer"
                                [src]="'assets/svg/trash-black.svg'"
                                (action)="removeProFromList(item)" />
                            </div>
                          }
                        </tidy-row>
                        @if (item?.object_type !== 'dynamic_sa') {
                          <tidy-row class="no-padding">
                            <tidy-checkbox
                              [initValue]="item?.ignore_homekeeper_availability"
                              [items]="[{viewValue: 'Auto Assign', value: true}]"
                              (checkedChange)="updateAutoAssign(item)"
                              matTooltip="Pro will be assigned immediately without needing to accept"
                              matTooltipShowDelay="200" />
                          </tidy-row>
                        }
                        @if (item?.object_type !== 'dynamic_sa' && !item?.ignore_homekeeper_availability && hasAutoAssignProAboveIndex(i)) {
                          <tidy-row class="no-padding">
                            <tidy-text
                              [helper]="'These will only be contacted if the auto assign pro cancels the job'"
                              [style.font-size]="'12px'"
                              [style.color]="'#666'" />
                          </tidy-row>
                        }
                      </div>
                    }
                  </tidy-card-button>
                </tidy-card>
              }
              @if (editPrio && !last) {
                <div
                  class="transparent-div"
                  (mouseenter)="highlightCards(i, i + 1, 'favorited')"
                  (mouseleave)="unhighlightCards(i, i + 1, 'favorited') ">
                  <img
                    (click)="mergePros(i, i + 1, 'favorited')"
                    src="assets/icon/compress-green.svg"
                    class="hover-icon"
                    [matTooltip]="'Merge' | translate"/>
                </div>
              }
            </ng-container>
          }
        </tidy-drag-drop>
        <tidy-row>
          <tidy-text
            [header]="'Settings'" />
        </tidy-row>
        <!--<tidy-row *ngIf="!editPrio">
          <tidy-text
            [body]="'We\'ll start sending your job request to pros no earlier than 30 days before the job\'s start time.'">
          </tidy-text>
        </tidy-row>-->
        @if (!editPrio) {
          <tidy-row>
            <tidy-text
              [body]="('We\'ll notify everyone on your list at least ' | translate) + form?.value?.timeCutoff + ((' hours before the job starts or ' | translate) + (form?.value?.percentCutoff | translate) + ('% of the time between your request time and the job start time, whichever is first.' | translate))" />
          </tidy-row>
        }
        @if (editPrio) {
          <form [formGroup]="form" novalidate action="#">
            <tidy-row>
              <div class="desktop-item">
                <tidy-select
                  class="select-custom-input"
                  [label]="'How much time before the job should we notify all pros?'"
                  [icon]="'assets/svg/time.svg'"
                  [items]="timeCutoffItems"
                  [form]="form.get('timeCutoff')"
                  formControlName="timeCutoff"
                  (optionChange)="updateTimeCutoff($event)" />
              </div>
            </tidy-row>
            <tidy-row>
              <div class="desktop-item">
                <tidy-select
                  class="select-custom-input"
                  [label]="'What % of the time before the job should we notify all pros?'"
                  [icon]="'assets/svg/time.svg'"
                  [items]="percentCutoffItems"
                  [form]="form.get('percentCutoff')"
                  formControlName="percentCutoff"
                  (optionChange)="updatePercentCutoff($event)" />
              </div>
            </tidy-row>
          </form>
        }
        @if (!allowsFindNewPros && !isAddressOutsideUS) {
          <tidy-row>
            <tidy-text
              [body]="'Find New Pros is disabled '" />
            @if (editPrio) {
              <tidy-text
                [body]="'Edit'"
                class="link"
                (action)="goToTidyFindNewPro(false)" />
            }
          </tidy-row>
        }
        @if (!allowsFindNewPros && isAddressOutsideUS) {
          <tidy-row>
            <tidy-alert class="yellow-background">
              <tidy-text
                [body]="'Find New Pros is disabled for addresses outside the US.'" />
            </tidy-alert>
          </tidy-row>
        }
      }
      @if (!hasPros && hasAddresses) {
        @if (!windowService.isDesktopRes) {
          <tidy-row [align]="'center'">
            <tidy-text
              [title]="'Prioritize Pros'" />
          </tidy-row>
        }
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Once you have had a Pro, this section lets you control who can do your jobs and in what order.'" />
        </tidy-row>
        <tidy-row [align]="'center'">
          <tidy-image
            [src]="'assets/img/calendar-down.svg'"
            style="width:70px" />
        </tidy-row>
        <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/add-pro.svg'"
              class="title-size" />
            <div style="width:140px"><ion-skeleton-text /></div>
            <div>
              <tidy-image
                [src]="'assets/img/block.svg'"
                class="title-size" />
            </div>
          </tidy-row>
        </tidy-card>
        <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/add-pro.svg'"
              class="title-size" />
            <div style="width:140px"><ion-skeleton-text /></div>
            <div>
              <tidy-image
                [src]="'assets/img/block.svg'"
                class="title-size" />
            </div>
          </tidy-row>
        </tidy-card>
        <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/add-pro.svg'"
              class="title-size" />
            <div style="width:140px"><ion-skeleton-text /></div>
            <div>
              <tidy-image
                [src]="'assets/img/checkmark-circle-blue.svg'"
                class="title-size" />
            </div>
          </tidy-row>
        </tidy-card>
        <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/add-pro.svg'"
              class="title-size" />
            <div style="width:140px"><ion-skeleton-text /></div>
          </tidy-row>
        </tidy-card>
        <tidy-row [align]="'center'" class="extra-top-padding">
          <tidy-text
            [body]="'Add a pro to send them jobs. It\'s easy and free for them. '" />
          <tidy-text
            [body]="'Learn More'"
            (action)="learnMoreAddPros()"
            class="link" />
        </tidy-row>
        <tidy-button
          [text]="'Add Pro'"
          [action]="boundAddPro"
          class="primary" />
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Settings for Finding New Pros'"
            (action)="goToTidyFindNewProFromOnboarding()"
            class="link" />
        </tidy-row>
      }
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }

    @if (!loaded && hasAddresses !== false) {
      <ion-skeleton-text animated style="margin-left: -20px; margin-right: -20px; width: 100%; position: absolute; height: 100%; top: 0; bottom: 0" />
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [isfullWidthContent]="windowService.isDesktopRes" [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
